import { useContext, useEffect, useState } from 'react';
import ClaimEntryComponent from './claim-entry.component';
import { useTranslation } from 'react-i18next';
import AppContext from '../data/AppContext';

function AllClaimsComponent({ mountainId, showFirst }) {
  const { voices } = useContext(AppContext);
  const [entries, setEntries] = useState([]);
  const [firstClaim, setFirstClaim] = useState(undefined);

  const { t } = useTranslation('app');

  useEffect(() => {
    if (mountainId) {
      setEntries(voices.filter((v) => v.mountainId === mountainId));
    } else {
      setEntries(voices);
    }
  }, [mountainId, showFirst, voices]);

  useEffect(() => {
    if (showFirst && entries.length > 1) {
      const e = [...entries];
      setFirstClaim(e.pop());
      // setEntries(e);
    } else {
      setFirstClaim(undefined);
    }
  }, [entries, showFirst]);

  return (
    <div>
      {firstClaim && (
        <>
          <h2 style={{ marginTop: '2.5rem', marginBottom: '1rem' }}>
            {t('mountain.firstVoice')}
          </h2>
          <ClaimEntryComponent
            claim={firstClaim}
            key={`first-${firstClaim.uuid}-${mountainId}`} // Unique key forces reset
          />
        </>
      )}

      {firstClaim && (
        <h2 style={{ marginTop: '2.5rem', marginBottom: '1rem' }}>
          {t('mountain.allVoices')}
        </h2>
      )}
      {entries.map((entry, id) => (
        <ClaimEntryComponent
          claim={entry}
          key={`${entry.uuid}-${mountainId}`} // Unique key forces reset
        />
      ))}
    </div>
  );
}

export default AllClaimsComponent;